// src/store/slices/solutionSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

const initialState = {
  solutions: [],
  currentSolution: null,
  loading: false,
  error: null,
  totalCount: 0,
};

export const fetchSolutions = createAsyncThunk(
  'solutions/fetchAll',
  async (params = {}, { rejectWithValue }) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const data = await api.get(`/solutions/?${queryString}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.data?.message || 'Failed to fetch solutions');
    }
  }
);

export const fetchSolution = createAsyncThunk(
  'solutions/fetchOne',
  async (id, { rejectWithValue }) => {
    try {
      const data = await api.get(`/solutions/${id}/`);
      return data;
    } catch (error) {
      return rejectWithValue(error.data?.message || 'Failed to fetch solution');
    }
  }
);

const solutionSlice = createSlice({
  name: 'solutions',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSolutions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSolutions.fulfilled, (state, action) => {
        state.loading = false;
        state.solutions = action.payload.results || [];
        state.totalCount = action.payload.count || 0;
      })
      .addCase(fetchSolutions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchSolution.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSolution.fulfilled, (state, action) => {
        state.loading = false;
        state.currentSolution = action.payload;
      })
      .addCase(fetchSolution.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = solutionSlice.actions;
export default solutionSlice.reducer;